module.exports = __webpack_public_path__ + "static/media/gamePaint.57939508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamePaint.png
// module id = 2316
// module chunks = 0